<template>
  <MModal
    ref="modal"
    class="m-modal__accounts"
    @apply="apply"
    @cancel="cancel"
  >
    <template slot="modal-header">
      {{ _('Moving options') }}
    </template>
    <template slot="modal-content">
      <MErrorWrapper
        :error-object="errorObject"
        :error-path="errorPath"
      >
        <SkeletonLoader
          v-if="isChoicesLoading"
          :is-loading="true"
          width="100%"
        />
        <MSelectControl
          v-if="!isChoicesLoading"
          class="m-select__modal-accounts"
          id-attr="id"
          text-attr="name"
          :choices="choices"
          :value="selected"
          :parent-is-option="true"
          :is-in-modal="true"
          popper-class="popper__account-page"
          @input="setSelectedAccount"
        />
      </MErrorWrapper>
    </template>
  </MModal>
</template>

<script>
  import MModal from 'legacy/modules/common/components/MModal/MModal';
  import {MSelectControl, SkeletonLoader, MErrorWrapper} from '@marilyn/marilyn-ui';

  export default {
    name: 'MovingAccountsModal',
    components: {
      MModal,
      MErrorWrapper,
      MSelectControl,
      SkeletonLoader
    },
    props: {
      choices: {
        type: Array,
        default: Array
      },
      errorObject: {
        type: Object,
        default: Object
      },
      errorPath: {
        type: String,
        default: 'errors.message'
      }
    },
    data () {
      return {
        selected: undefined
      };
    },
    computed: {
      isChoicesLoading () {
        return !this.choices || this.choices.length === 0;
      }
    },
    methods: {
      setSelectedAccount (accId) {
        this.selected = accId;
        this.$emit('select');
      },
      apply () {
        this.$emit('apply', this.selected);
      },
      cancel () {
        this.$emit('cancel');
      },
      removeModal () {
        return this.$refs.modal.removeModal();
      }
    }
  };
</script>
